module.exports = __webpack_public_path__ + "media/newstyle/images/agbook-logo-editor-load-6f6026ccdd35c4384feb337b28682441.jpg";